import { Injectable } from '@angular/core';
import { CreateDokladovaRadaDto, EditDokladovaRadaDto, DokladovaRadaDto } from "./models/DokladovaRadaDtos"
import { HttpClient } from "@angular/common/http";
import {CrudSettings, MapperEntity, MapperKeys, QueryParams} from "../shared/crud/abstractions/base-crud";
import { EnvironmentService } from '../core/environment/environment.service';
import { BehaviorSubject, lastValueFrom, Observable } from 'rxjs';


@Injectable({
    providedIn: null
  })
export class DokladovaRadaCrudSettings implements CrudSettings<string, DokladovaRadaDto> {
  baseUrl = '';
  postUrl = undefined;
  queryParam = undefined;
  createSuffix = undefined;
  deleteSuffix = undefined;
  deleteIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  editSuffix = undefined;
  editMethod: 'PUT' | 'PATCH' = 'PUT';
  editIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  getListSuffix = 'Vse';
  getSuffix = undefined;
  getIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  idGetter = (entity: DokladovaRadaDto) => entity.kodUj;

  mapper(id: string): QueryParams {
    const dict = new Map<string, string>();
    dict.set('kodUj', id);
    return { params: dict }
  }

  constructor(private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.getConfig().api.pubgw + '/api/UcetniDenik/DokladovaRada';
  }
}

@Injectable({
  providedIn: null
})
export class DokladovaRadaDataService{

  private client: HttpClient;
  private settings : DokladovaRadaCrudSettings;
  public isBusy$: BehaviorSubject<boolean>

  constructor(client: HttpClient, settings: DokladovaRadaCrudSettings) {
    this.client = client;
    this.settings = settings;
    this.isBusy$ = new BehaviorSubject<boolean>(false)
}
  public async getAll(params: any): Promise<Array<DokladovaRadaDto>>{
    let urlParams = this.getParamsUrl(params);
    this.isBusy$.next(true);
    const res$ = this.client.get<Array<DokladovaRadaDto>>(`${this.settings.baseUrl}/${this.settings.getListSuffix ? this.settings.getListSuffix+'?' : ''}${urlParams ? urlParams : ""}`);
    let res = await lastValueFrom(res$);
    this.isBusy$.next(false);
    return res;
  }

  public async edit(params: any, body: EditDokladovaRadaDto){
    let urlParams = this.getParamsUrl(params);
    this.isBusy$.next(true);
    const res$ = this.client.put(`${this.settings.baseUrl}?${urlParams ? urlParams : ""}`, body);
    let res = await lastValueFrom(res$);
    this.isBusy$.next(false);
    return res;
  }
  public async create(params: any, body: CreateDokladovaRadaDto, suffix: string){
    let urlParams = this.getParamsUrl(params);
    this.isBusy$.next(true);
    const res$ = this.client.post(`${this.settings.baseUrl}${suffix ? "/" + suffix : ""}?${urlParams ? urlParams : ""}`, body);
    let res = await lastValueFrom(res$);
    this.isBusy$.next(false);
    return res;
  }

  public async createMany(params: any, body: CreateDokladovaRadaDto[]){
    let urlParams = this.getParamsUrl(params);
    this.isBusy$.next(true);
    const res$ = this.client.post(`${this.settings.baseUrl}/CreateMany?${urlParams ? urlParams : ""}`, body);
    let res = await lastValueFrom(res$);
    this.isBusy$.next(false);
    return res;
  }
  public async delete(params: any){
    let urlParams = this.getParamsUrl(params);
    this.isBusy$.next(true);
    const res$ = this.client.delete(`${this.settings.baseUrl}?${urlParams ? urlParams : ""}`);
    let res = await lastValueFrom(res$);
    this.isBusy$.next(false);
    return res;
  }

  getParamsUrl(params: Map<MapperKeys,any>){
    const urlParams = new URLSearchParams();
    params.forEach((value, key) => {
      urlParams.append(key, value.toString());
    });
    return urlParams
  }
  setMapper(entity: MapperEntity | MapperEntity[]): Map<MapperKeys,any>
  {
    let dict = new Map()
    dict = new Map()
    if(Array.isArray(entity))
    {
      for (const element of entity)
      {
        dict.set(element.key,element.value)
      }
      return dict
    }
    return dict.set(entity.key,entity.value)
  }
}
